import type { IconSvgObject } from './types';

const ParenthesesIcon: IconSvgObject = [
  ["path", { d: "M5.99219 3C3.58119 4.93486 1.99219 8.24345 1.99219 12C1.99219 15.7565 3.58119 19.0651 5.99219 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.9922 3C20.4032 4.93486 21.9922 8.24345 21.9922 12C21.9922 15.7565 20.4032 19.0651 17.9922 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ParenthesesIcon;
